import ReactGA from 'react-ga';
import config from '../helpers/config';

ReactGA.initialize(config.ga.gaTrackingID);

export default ReactGA;